const sendInFeedCardToGA4 = () => {
  const buttons = document.querySelectorAll(
    ".featured__product-default-card button"
  );
  if (!buttons.length) {
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const selectContentObject = {
        content_type: "in-feed card",
        content_title: button.dataset.contentTitle,
        content_landing_page: button.dataset.contentLandingPage,
      };
      Shopify.analytics.publish("select_content", selectContentObject);
    });
  });
};

const sendInFeedShogunToGA4 = () => {
  const shogunLinks = document.querySelectorAll(".shogun-image-link");
  const titles = document.querySelectorAll("h1 > a");

  if (!shogunLinks.length || !titles.length) {
    return;
  }

  shogunLinks.forEach((link, index) => {
    link.addEventListener("click", () => {
      const selectContentObject = {
        content_type: "in-feed shogun",
        content_title: titles[index].innerText,
        content_landing_page: link.href,
      };
      Shopify.analytics.publish("select_content", selectContentObject);
    });
  });
};

const sendSelectStockistToGA4 = () => {
  if (window.location.pathname !== "/pages/store-locator") {
    return;
  }

  const _handleMutationsLiElement = (mutations) => {
    let tempId = null;
    for (const mutation of mutations) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.classList.contains("stockist-selected") &&
        tempId !== mutation.target.dataset.stockistIdTempDoNotUse
      ) {
        tempId = mutation.target.dataset.stockistIdTempDoNotUse;
        const stockistObject = {
          stockist_name: mutation.target.innerText.split("\n")?.[0] ?? "",
          stockist_location: mutation.target.innerText.split("\n")?.[1] ?? "",
        };

        Shopify.analytics.publish("select_stockist", stockistObject);
      }
    }
  };

  const _handleMutationsStockistList = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === "UL") {
            const observer = new MutationObserver(_handleMutationsLiElement);
            Array.from(node.children).forEach((child) => {
              observer.observe(child, {
                attributes: true,
                attributeFilter: ["class"],
              });
            });
          }
        });
      }
    }
  };

  const observer = new MutationObserver(_handleMutationsStockistList);
  const interval = setInterval(() => {
    const stockistResultList = document.querySelector(".stockist-result-list");
    if (!stockistResultList) {
      return;
    }
    clearInterval(interval);
    observer.observe(stockistResultList, {
      childList: true,
    });
  }, 200);
};

const sendNewsletterSignupToGA4 = () => {
  const newsletterSignupForms = document.querySelectorAll(".newsletter-form");

  Array.from(newsletterSignupForms).forEach((form) => {
    form.addEventListener("submit", (e) => {
      // e.preventDefault();

      // try {
      //   fetch(form.action, {
      //     method: "POST",
      //     body: new FormData(form),
      //   });
      // } catch (error) {
      //   console.error("Error when submitting newsletter form: ", error);
      // }

      Shopify.analytics.publish("sign_up");
    });
  });
};

let monsterCartLoaded = false;
const sendRemoveOrAddFromMonsterCartToGa4 = () => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.id === "monster-upsell-cart" && !monsterCartLoaded) {
            monsterCartLoaded = true;
            node.addEventListener("click", (event) => {
              const closestCartItem = event.target.closest(".mu-cart-item");
              const variantId = closestCartItem
                ?.querySelector("a")
                ?.href?.split("variant=")[1];
              const closestBtn = event.target.closest("button");
              const ariaLabel = closestBtn?.getAttribute("aria-label");
              if (
                (ariaLabel?.includes("decrease") ||
                  ariaLabel?.includes("remove")) &&
                variantId
              ) {
                sendUpsellAddToCartToGA4();
              }
              if (ariaLabel?.includes("increase") && variantId) {
                setGa4CartObjectToSessionStorage(+variantId);
              }
            });
            observer.disconnect();
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

// use in quick-add.js, main-product.liquid, featured-product.liquid
const sendUpsellAddToCartToGA4 = () => {
  let counter = 0;
  const interval = setInterval(() => {
    const button = $('button:has(span:contains("Add To Cart"))')[0];
    if (button) {
      clearInterval(interval);
      if (button.hasClickListener) {
        return;
      }

      button.hasClickListener = true;
    }
    if (counter > 10) {
      clearInterval(interval);
      console.error(
        "Cannot find Add To Cart button. Event upsell_add_to_cart will not be pushed"
      );
    }
    counter++;
  }, 500);
};

// handle traditional cart
const sendRemoveOrAddCartObjectToGA4 = () => {
  const cartContentsForm = document.querySelector("#cart");
  if (!cartContentsForm) {
    return;
  }

  cartContentsForm.addEventListener("click", (event) => {
    const cartItem = event.target.closest("tr");
    if (!cartItem) {
      return;
    }

    const quantityInput = cartItem.querySelector(".quantity__input").value;
    const variantId = cartItem.dataset.variantId;
    const ga4ObjectFromSessionStorage = JSON.parse(
      sessionStorage.getItem(`${variantId}`)
    );
    const buttonName = event.target.getAttribute("name");
    if (ga4ObjectFromSessionStorage) {
      ga4ObjectFromSessionStorage.quantity = 1;
      ga4ObjectFromSessionStorage.value = ga4ObjectFromSessionStorage.price;
    } else {
      console.error(
        "Cannot push object for increase_quantity/remove_from_cart event. No object found for the event"
      );
      return;
    }

    if (buttonName === "minus") {
      ga4ObjectFromSessionStorage.event = "remove_from_cart";
      if (quantityInput === "0") {
        sessionStorage.removeItem(variantId);
      }
      _modifyGa4ObjectForRemoveFromCartEvent(ga4ObjectFromSessionStorage);
      Shopify.analytics.publish(
        "remove_from_cart",
        ga4ObjectFromSessionStorage
      );
    }

    if (buttonName === "plus") {
      ga4ObjectFromSessionStorage.event = "increase_quantity";
      Shopify.analytics.publish(
        "increase_quantity",
        ga4ObjectFromSessionStorage
      );
      setG4CartObjectToSessionStorage(+variantId);
    }

    if (event.target.closest("a")) {
      ga4ObjectFromSessionStorage.event = "remove_from_cart";
      sessionStorage.removeItem(variantId);
      ga4ObjectFromSessionStorage.value =
        ga4ObjectFromSessionStorage.price * quantityInput;
      ga4ObjectFromSessionStorage.quantity = quantityInput;
      _modifyGa4ObjectForRemoveFromCartEvent(ga4ObjectFromSessionStorage);
      Shopify.analytics.publish(
        "remove_from_cart",
        ga4ObjectFromSessionStorage
      );
    }
  });
};

const sendVideoToGa4 = () => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.tagName === "VIDEO") {
            node.addEventListener("play", (event) => {
              const videoElement = event.target;
              const videoStartObject = constructVideoStartObject(
                videoElement.getAttribute("aria-label") ?? "",
                Math.round(videoElement.duration)
              );
              if (videoElement.currentTime < 1 && window.dataLayer) {
                console.log("Pushed video start object: ", videoStartObject);
                Shopify.analytics.publish("video_start", videoStartObject);
              }
            });

            node.addEventListener("pause", (event) => {
              const videoElement = event.target;
              const videoTitle = videoElement.getAttribute("aria-label") ?? "";
              const videoCurrentTime = Math.round(videoElement.currentTime);
              const videoDurarion = Math.round(videoElement.duration);
              const videoPercent = Math.round(
                (videoCurrentTime / videoDurarion) * 100
              );
              const videoProgressObject = constructVideoProgressObject(
                videoTitle,
                videoCurrentTime,
                videoPercent,
                videoDurarion
              );
              if (videoPercent < 100) {
                Shopify.analytics.publish(
                  "video_progress",
                  videoProgressObject
                );
              }
            });

            node.addEventListener("ended", (event) => {
              const videoElement = event.target;
              const videoTitle = videoElement.getAttribute("aria-label") ?? "";
              const videoDurarion = Math.round(videoElement.duration);
              const videoPercent = 100;
              const videoCompleteObject = constructVideoCompleteObject(
                videoTitle,
                videoPercent,
                videoDurarion
              );
              Shopify.analytics.publish("video_complete", videoCompleteObject);
            });
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

const sendLoginToGa4 = () => {
  const customerId = _getCustomerId();
  if (customerId) {
    Shopify.analytics.publish("login", {
      user_id: customerId,
    });
  }
};

window.document.addEventListener("DOMContentLoaded", function () {
  console.log("GA4 loaded");

  sendInFeedCardToGA4();
  sendInFeedShogunToGA4();
  sendSelectStockistToGA4();
  sendNewsletterSignupToGA4();
  sendRemoveOrAddFromMonsterCartToGa4();
  sendRemoveOrAddCartObjectToGA4();
  sendVideoToGa4();
  sendLoginToGa4();
});

// videos ga4 youtube

let lastTime = 0;
let currentTime = 0;

function onYouTubeIframeAPIReady() {
  console.log("Youtube API ready");
  const videos = document.querySelectorAll(".shogun-video-embed");
  Array.from(videos).forEach((video) => {
    let player = new YT.Player(video, {
      events: {
        onStateChange: onPlayerStateChange,
      },
    });
  });
}

const onPlayerStateChange = (event) => {
  if (event.data == YT.PlayerState.PLAYING) {
    const currentTime = event.target.playerInfo.currentTime;
    const videoStartObject = constructVideoStartObject(
      event.target.videoTitle,
      Math.round(event.target.playerInfo.duration)
    );
    if (currentTime < 1 && window.dataLayer) {
      Shopify.analytics.publish("video_start", videoStartObject);
    }
  }

  if (event.data === YT.PlayerState.PAUSED) {
    const videoTitle = event.target.videoTitle;
    const videoCurrentTime = Math.round(event.target.playerInfo.currentTime);
    const videoDuration = Math.round(event.target.playerInfo.duration);
    const videoPercent = Math.round((videoCurrentTime / videoDuration) * 100);
    const videoProgressObject = constructVideoProgressObject(
      videoTitle,
      videoCurrentTime,
      videoPercent,
      videoDuration
    );
    Shopify.analytics.publish("video_progress", videoProgressObject);
  }

  if (event.data === YT.PlayerState.ENDED) {
    const videoTitle = event.target.videoTitle;
    const videoDuration = Math.round(event.target.playerInfo.duration);
    const videoPercent = 100;
    const videoCompleteObject = constructVideoCompleteObject(
      videoTitle,
      videoPercent,
      videoDuration
    );
    Shopify.analytics.publish("video_complete", videoCompleteObject);
  }
};

// helpers

const constructVideoStartObject = (videotitle, videoDuration) => {
  return {
    video_title: videotitle,
    video_duration: videoDuration,
  };
};

const constructVideoProgressObject = (
  videoTitle,
  videoCurrentTime,
  videoPercent,
  videoDuration
) => {
  return {
    video_title: videoTitle,
    video_current_time: videoCurrentTime,
    video_percent: videoPercent,
    video_duration: videoDuration,
  };
};

const constructVideoCompleteObject = (
  videoTitle,
  videoPercent,
  videoDuration
) => {
  return {
    video_title: videoTitle,
    video_percent: videoPercent,
    video_duration: videoDuration,
  };
};

const constructGA4CartObject = (item, event = "") => {
  return {
    value: item.line_price / 100.0,
    currency: Shopify.currency.active,
    item_name: item.product_title,
    item_id: `shopify_GB_${item.product_id}_${item.variant_id}`,
    price: item.price / 100.0,
    item_category: item.product_type,
    quantity: item.quantity,
  };
};

const setGa4CartObjectToSessionStorage = (variantId) => {
  getGa4Object(variantId).then((ga4Object) => {
    const variantId = ga4Object._variantId;
    delete ga4Object._variantId;
    sessionStorage.setItem(variantId, JSON.stringify(ga4Object));
  });
};

// Function used to construct object for quick_add_to_cart event and update sessionStorage for remove_from_cart event
const getGa4Object = (variantId) => {
  return new Promise((resolve, reject) => {
    let intervalCounter = 0;
    let ga4Object = null;
    const getCartItems = () => {
      if (intervalCounter > 10) {
        reject(null);
      }
    };
    getCartItems();
  });
};

const _getCustomerId = () => {
  try {
    let curr = window.ShopifyAnalytics.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {}
  try {
    let curr = window.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {}
  return null;
};

const _modifyGa4ObjectForRemoveFromCartEvent = (
  ga4ObjectFromSessionStorage
) => {
  ga4ObjectFromSessionStorage.items = [
    {
      item_name: ga4ObjectFromSessionStorage.item_name,
      item_id: ga4ObjectFromSessionStorage.item_id,
      price: ga4ObjectFromSessionStorage.price,
      item_category: ga4ObjectFromSessionStorage.item_category,
      quantity: ga4ObjectFromSessionStorage.quantity,
    },
  ];

  const propertiesToRemove = [
    "item_name",
    "item_id",
    "price",
    "item_category",
    "quantity",
  ];
  propertiesToRemove.forEach(
    (prop) => delete ga4ObjectFromSessionStorage[prop]
  );
};
